import { forwardRef, type Ref, type SVGProps } from "react";
const IconPharmacyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.37 8.502a6 6 0 0 1-1.471 6.086L14.592 25.895A6.004 6.004 0 1 1 6.1 17.404L17.408 6.097q.116-.117.237-.225l.01-.01a6.005 6.005 0 0 1 9.715 2.64m-14.909 5.37-4.946 4.946a4.004 4.004 0 1 0 5.663 5.663l4.946-4.947zm9.906-5.651a1 1 0 0 1 1.414 0c1.248 1.247 1.012 3.23-.177 4.42l-2.651 2.65a1 1 0 1 1-1.415-1.414l2.652-2.651c.569-.569.491-1.277.177-1.591a1 1 0 0 1 0-1.414"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPharmacyFilledSVG);
ForwardRef.displayName = "IconPharmacyFilled";
export { ForwardRef as IconPharmacyFilled };
